import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from 'react-router-dom';
import { queryClient } from '@/lib/query-client';
import { router } from '@/routes';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { BrandedThemeProvider } from '@/components/BrandedThemeProvider';
import { startSessionWatch } from '@/lib/session';
import { installChunkErrorRecovery } from '@/lib/chunk-reload';

// Before the first render: an expired sign-in must send the user to the login
// page (not an error), and a page chunk removed by a deploy must reload onto
// the new build (not "Failed to fetch dynamically imported module").
startSessionWatch();
installChunkErrorRecovery();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* BrandedThemeProvider watches the active entity's primary_color and
          rebuilds the MUI theme whenever it changes. Wraps the QueryClient
          because it itself uses React Query to fetch branding. */}
      <BrandedThemeProvider>
        <CssBaseline />
        {/* Outer ErrorBoundary catches anything route-level boundaries don't —
            e.g. a crash inside the router itself. Inner per-route boundaries
            are the primary recovery point. */}
        <ErrorBoundary>
          {/* On React Router v7 startTransition wrapping is the built-in
              behaviour, so the former v7_startTransition opt-in is gone. */}
          <RouterProvider router={router} />
        </ErrorBoundary>
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </BrandedThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
